<template>
  <div class="d-flex justify-content-center mt-3">

    <b-row>
      <b-col
        md="6"
        lg="4"
      >

        <!-- card 1 -->
        <b-card
          class="text-center"

          title="Fatura Raporları"
        >
          <div class="text-left">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="flat-primary"
            >
              Aktif Enerji Fatura Özet Raporu
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="flat-primary"
            >
              Fatura Kontrol Raporu
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="flat-primary"
            >
              Fatura Tüketim Raporu
            </b-button><br>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="flat-primary"
            >
              Fatura Kalem Raporu
            </b-button><br>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="flat-primary"
            >
              Sektör Bazlı Tüketim Raporu
            </b-button>
          </div>
        </b-card>
      </b-col>

      <!-- card 2 -->
      <b-col
        md="6"
        lg="4"
      >
        <b-card
          class="text-center"
          title="Tüketim Raporları"
          header-tag="h6"
        ><br><br>
          <div class="text-left">
            <b-button variant="flat-primary">
              Sayaç Tüketim Raporu
            </b-button><br>
            <b-button variant="flat-primary">
              Sayaç Endeks Raporu
            </b-button><br>
            <b-button variant="flat-primary">
              OSOS Endeks Raporu
            </b-button><br>
            <b-button variant="flat-primary">
              Dönem Analiz Raporu
            </b-button>
          </div>
        </b-card>
      </b-col>

      <!-- card 3 -->
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard, BRow, BCol, BButton,
  },
  directives: {
    Ripple,
  },
}
</script>
